<div class="preview">

  <mat-card *ngIf="tab === 'thumbnail'" class="offer_start">
    <div class="loading" *ngIf="isLoading">
      <mat-spinner [color]="color" [diameter]="50"></mat-spinner>
    </div>

    <ng-container *ngIf="image; else defaultImageTemplate">
      <img mat-card-image [src]="image" alt="Photo">
    </ng-container>

    <ng-template #defaultImageTemplate>
      <img mat-card-image [src]="imgDefault" alt="Photo">
    </ng-template>

    <mat-card-content>
      <div class="photo_experience" *ngIf="getPhotoExperience(offer?.photoExperience)">
        <p>{{offer?.photoExperience || 'Photo experience'}}</p>
      </div>
      <div class="photo_experience_bas">
        <div class="photo_experience_bas_item" *ngIf="offer?.photoExperienceBas">
          <p>{{offer?.photoExperienceBas}}</p>
        </div>
        <div *ngIf="!offer?.photoExperienceBas">
        </div>
        <div class="photo_experience_bas_item" *ngIf="offer?.discipline">
          <p>{{offer?.discipline}}</p>
        </div>
      </div>

      <h4><strong>{{offer?.offerName || 'Titre de l\'article'}}</strong></h4>

      <div class="tags">
        <ng-container *ngFor="let t of offer?.mainTags, let i = index">
          <div class="tag">{{t.tagName}} </div>
        </ng-container>
      </div>
      <p class="description" *ngIf="offer?.description" [innerHTML]="offer.description">
      </p>
      <p class="description" *ngIf="!offer?.description">
        Description de l'article
      </p>

    </mat-card-content>

    <div class="btn_action">
      <!-- <div class="price">
        <div class="icon">
          <fa-icon [icon]="getFaIcon('faEuroSign')" appChangeColorTheme attribute="color"></fa-icon>
        </div>
        <span> {{offer?.price || 'Prix de l\'article'}} </span>
      </div> -->


      <fa-icon [icon]="getFaIcon('faHeartEmpty')" appChangeColorTheme attribute="color">
      </fa-icon>
    </div>
  </mat-card>



</div>
